"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var vc_build_output_config_base_exports = {};
__export(vc_build_output_config_base_exports, {
  vercelBuildOutputConfigBase: () => vercelBuildOutputConfigBase
});
module.exports = __toCommonJS(vc_build_output_config_base_exports);
var vercelBuildOutputConfigBase = {
  version: 3,
  // Note: cleanUrls is NOT supported in the Build Output API config.json
  // Users must add "cleanUrls": true to their vercel.json at project root
  // https://vercel.com/docs/build-output-api/v3/configuration#routes
  routes: []
};
//# sourceMappingURL=vc-build-output-config-base.js.map
